const subfoldersOfficialIdSlugMap: any = {
  "tenant-pf": "del inquilino",
  "tenant-pm": "del inquilino (representante legal)",
  "tenant-pf-cja": "del inquilino",
  "tenant-pm-cja": "del inquilino (representante legal)",
  "guarantor-pf": "del obligado solidario",
  "guarantor-pf-cja": "del obligado solidario",
  "guarantor-pm": "del obligado solidario (representante legal)",
  "guarantor-pm-cja": "del obligado solidario (representante legal)",
  "guarantor-investigation-pf": "del obligado solidario",
  "guarantor-investigation-pm": "del obligado solidario (representante legal)",
  "lease-contract-pf": "del propietario",
  "lease-contract-pm": "del propietario (representante legal)",
};

const subfoldersProofOfIncomeSlugMap: any = {
  ...subfoldersOfficialIdSlugMap,
  "tenant-pm": "de la empresa",
  "tenant-pm-cja": "de la empresa",
  "guarantor-pm": "de la empresa",
  "guarantor-investigation-pm": "de la empresa",
  "lease-contract-pm": "de la empresa",
};

const subfoldersProofOfAddressSlugMap: any = {
  ...subfoldersProofOfIncomeSlugMap,
};

const subfoldersBDCAuthorizationSlugMap: any = {
  "tenant-pf": "del inquilino",
  "tenant-pm": "del inquilino (representante legal)",
  "guarantor-pf": "del obligado solidario",
  "guarantor-pm": "del obligado solidario (representante legal)",
  "guarantor-investigation-pf": "del obligado solidario",
  "guarantor-investigation-pm": "del obligado solidario (representante legal)",
};

const requirementsSlugMap: any = {
  "official-id": subfoldersOfficialIdSlugMap,
  "proof-of-income": subfoldersProofOfIncomeSlugMap,
  "proof-of-address": subfoldersProofOfAddressSlugMap,
  "bdc-authorization": subfoldersBDCAuthorizationSlugMap,
};

export const getRequirementNameBySlug = (
  subfolderSlug: string,
  requirementSlug: string,
  requirementName: string,
) => {
  if (!requirementsSlugMap[requirementSlug]) return requirementName;

  const slugName = requirementsSlugMap[requirementSlug][subfolderSlug];
  return `${requirementName} ${slugName}`;
};
